import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { PRODUCT } from "./data";
import { LANDING } from "@/constants/testIds";

export default function FloatingWhatsapp() {
  return (
    <motion.a
      href={PRODUCT.whatsappUrl}
      data-testid={LANDING.whatsappFloating}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, duration: 0.5, type: "spring" }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-[0_15px_40px_-5px_rgba(37,211,102,0.45)] hover:shadow-[0_20px_50px_-5px_rgba(37,211,102,0.6)] transition-shadow duration-300"
      aria-label="Conversar no WhatsApp"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2} fill="white" stroke="#25D366" />
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
    </motion.a>
  );
}
